export const getTimes = (data: CampaignDashboardDataRecord[]) => [...new Set(data.map(i => i.time))]

export const getAppeals = (data: CampaignDashboardDataRecord[]) => [...new Set(data.map(i => i.appealCode))]

export const getSeries = (data: CampaignDashboardDataRecord[] | undefined, groupByDonors: boolean, chartStyle = 'bar') =>
    data && getAppeals(data).map(i => ({
        name: i || 'No Appeal',
        type: chartStyle,
        barWidth: '40%',
        stack: 'stack',
        data: groupByDonors ? getDonors(data, i) : getDollars(data, i),
    }))

export const getGraphOptionDefaults = (instanceSettings: DashboardSettingsDto | undefined) => {
    const defaultColors = ['#1D3B53', '#1973B2', '#A1D7D7', '#92C453', '#E76124', '#F8C44A', '#A878CE', '#C2C9CF', '#42C896', '#C91E4A']
    const colors = instanceSettings!.layoutSettings.overrideChartColorsEnabled ? (instanceSettings!.layoutSettings.overrideChartColors.length > 0 ? instanceSettings!.layoutSettings.overrideChartColors : defaultColors) : defaultColors
    return {
        color: colors,
        grid: {
            left: '8%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
            },
        },
    }
}

export const getDonors = (data: CampaignDashboardDataRecord[], appealCode: string | null) =>
    data.filter(record => record.appealCode === appealCode).map(x => x.totalDonations)

export const getDollars = (data: CampaignDashboardDataRecord[], appealCode: string | null) =>
    data.filter(record => record.appealCode === appealCode).map(x => x.totalDollars)
